import styled from 'styled-components'

import media from '../../../../services/generateMediaQueries'

import CatalogList from '../../../../components/home/CatalogList/CatalogList'
import TextInput from '../../../../components/ui/TextInput/TextInput'
import ShopDineListCard from '../../../../components/home/ShopDineListCard/ShopDineListCard'

import rewardsBanner from '../../../../assets/img/rewards/rewardsBanner.webp'

export const StyledBanner = styled.div.attrs(() => ({
  style: {
    background: `linear-gradient(
        to bottom right,
        rgba(231, 71, 94, 0.95) 0%,
        rgba(235, 118, 50, 0.95) 100%
      ), url('${rewardsBanner}') top / cover no-repeat`,
  },
}))`
  width: 100%;
  height: 430px;

  ${media.lessThan('small')`
      height: 500px;
      padding-top: 70px;
    `}
`

export const BannerContent = styled.div`
  background: linear-gradient(180deg, #000000 0%, rgba(0, 0, 0, 0) 158px);
  width: 100%;
  // max-width: 1024px;
  height: 430px;
  // margin: 0 auto;
  padding: 0 auto;

  display: flex;
  align-items: center;
`

export const BannerDescription = styled.div`
  width: 100%;
  padding: 0 1rem;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  color: #ffffff;
`

export const Heading = styled.div`
  ${media.lessThan('large')`
      padding: 0 1.5rem;
    `}

  ${media.lessThan('small')`
      padding: 0 1rem;
    `}
`
export const FormContainer = styled.div`
  display: flex;
`

export const InputContainer = styled.div`
  flex: 2;
`

export const StyledCatalogList = styled(CatalogList)`
  ${media.lessThan('large')`
      margin: 0 1rem;
      justify-content: space-around;
    `}
`

export const StyledShopDineListCard = styled(ShopDineListCard)`
  margin: 0 0.5rem;
  margin-bottom: 1rem !important;

  ${media.lessThan('small')`
      margin: 0;
    `}
`

export const StyledTextInput = styled(TextInput)`
  background-color: white;
  border: none;
  border-radius: var(--border-radius-form);
  box-shadow: 0px 8px 10px 0px rgba(0, 0, 0, 0.05);

  &::placeholder {
    opacity: 0.5;
  }
`

export const RewardsCatalogTitle = styled.h2`
  font-size: 2rem;
  font-weight: var(--font-weight-boldest);
  line-height: 2.5rem;
  letter-spacing: 0.44px;
  text-transform: uppercase;
  margin: 0;

  ${media.lessThan('small')`
      font-size: 1.375rem;
    `}
`

export const RewardsCatalogDescription = styled.p`
  font-size: 1.5rem;
  line-height: 1.5;
  letter-spacing: 0.5px;
  text-align: center;
  margin: 0;
  margin-top: 1rem;

  ${media.lessThan('small')`
      font-size: 1.125rem;
    `}
`

export const sectionDescription = {
  order: {
    title: 'Order Now',
    description:
      'Relax, de-stress, and find something amazing to experience at Ayala Malls.',
  },
  shop: {
    title: 'Shop',
    description:
      'Discover what’s new and amazing in fashion, footwear, accessories, and more at Ayala Malls.',
  },
  dine: {
    title: 'Dine',
    description:
      'Go on a gastronomic adventure with an amazing lineup of cuisines, tastes, and flavors at Ayala Malls.',
  },
  unwind: {
    title: 'Unwind',
    description:
      'Relax, de-stress, and find something amazing to experience at Ayala Malls.',
  },
}
